.hint,
.tip {
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
}

.hint {
  margin: -8px 0 16px;
}

.tip {
  margin-top: 8px;
}

.coverPreview {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 12px;
}

.coverPreview img {
  width: 96px;
  height: 128px;
  object-fit: cover;
  background: var(--ant-color-fill-secondary);
  border-radius: var(--ant-border-radius-sm);
}

.cardList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card {
  padding: 12px;
  background: var(--ant-color-fill-alter);
  border: 1px solid var(--ant-color-border-secondary);
  border-radius: var(--ant-border-radius);
}

.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: 500;
}

.avatar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.avatar img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 50%;
}
